import { useCallback } from 'react';
import Style from './formInput.module.scss';
import { downloadFile } from 'src/helpers/file-helper';
import { FormFileInputComponent } from 'src/features/generalForms/builder/types/FileInput';
import { getFileById } from 'src/services/api/api-client/FilesClient';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { AppAttachmentValue } from 'uikit/fields/attachments/attachmentsField/appAttachmentsField';
import { AppButton } from 'uikit/buttons';
import { ReactComponent as FileIcon } from 'src/assets/img/comment/file.svg';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';

export const FormFileInput: FormFileInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();

  const downloadHandler = useCallback(async (id: string | null) => {
    if (!id) throw new Error('Attachment id is not provided');
    const response = await getFileById(id);
    downloadFile(response);
  }, []);

  if (!visible) {
    return <></>;
  }

  return (
    <AnswerPreviewRow<AppAttachmentValue[]>
      {...props}
      value={value}
      renderValue={(val) => (
        <div className={Style.fileAnswerContainer}>
          {val.map((x) => (
            <AppButton
              key={x.id}
              colorSchema={'primary'}
              variant={'icon-link'}
              Icon={FileIcon}
              text={x.fileName}
              onClick={() => downloadHandler(x.id)}
              textClassName={Style.fileName}
            />
          ))}
        </div>
      )}
    />
  );
};
